import { SearchContainer, JobsContainer } from '../../components';

export default function AllJobs() {
  return (
    <>
      <SearchContainer />
      <JobsContainer />
    </>
  );
}
